import classNames from "classnames";
import { Link, LinkProps } from "react-router-dom";
import { getNotFoundImg } from "@outplayed/riot-assets";

export function LeaderboardError({
  className,
  message,
  resetLink,
}: {
  className?: string;
  message?: string;
  resetLink?: LinkProps["to"];
}) {
  return (
    <div
      className={classNames(
        `flex flex-col justify-center items-center px-[12px] py-[80px] 
      rounded-[3px] bg-purple-400 text-[16px] font-medium text-center`,
        className,
      )}
    >
      <img className="mb-[15px] min-w-[50px] max-w-[200px]" src={getNotFoundImg()} alt="No data found" />
      <p>{message || "Sorry, there is no data available. Please try changing the filters or page."}</p>
      {resetLink && (
        <p>
          <Link className="underline" to={resetLink}>
            Click Here
          </Link>{" "}
          to reset filters.
        </p>
      )}
    </div>
  );
}
